'use client'
import { publicRuntimeConfig } from '@/app/util/env'
import Grid from '@/components/grid/grid'
import { GiphyFetch } from '@giphy/js-fetch-api'

// use the 404 api key
const giphyFetch = new GiphyFetch(publicRuntimeConfig.fourOhFourApiKey)

const ErrorGrid = () => {
    return <Grid fetchGifs={(offset: number) => giphyFetch.trending({ offset })} />
}
export default ErrorGrid
